
export class Sales 
{
  public id: string;
  public saleID: number;
  public saleTypeID: number;
  public paymentMethodID: number;
  public domainType: number;
  public  title: string;
  public description: string;
  public saleLogo: string;
  public isActive: boolean;
  public startDate: string;
  public endDate: string;
  public applyDate: string; 
  //public applyDate: string;
  public dicsountPercent: number;
  public saleCategories: SaleCategories[];
  public saleProducts: SaleProducts[];
}
export class SaleCategories {
  public id: string;
  public saleID: number;  
  public parentCategoryID : number;
  public categoryID: number;
  public subCategoryID: number;
  public parentCategoryName: string;
  public categoryName: string;
  public subCategoryName: string;
  public criteria: number;
}
export class SaleProducts {
  public id: string;
  public saleID: number;
  public productID: number;
  public productName: number;
  public companyParticipation: number = 0;
  public venderParticipation: number=0;
  public productSku: string;
  public isEnable: boolean;
  public regularPrice: number;
  public discountType: number;
  public venderID: number;
  public venderName: string;
  public disable: boolean = true;
  public showProductFixed: boolean = true;
  public showProductPercent: boolean = false;
  public url: string;
  public path: string;
  public thumbnailImage: string;
  public DateTime: Date;
}









// WEBPACK FOOTER //
// ./src/app/models/sales/sales.model.ts